"use client";
import { ButtonDark } from "@/stories/Button.stories";
import {
    CardLgWithImg,
    CardMdHighNoButton,
    CardMdNoButton,
    CardSm,
} from "@/stories/Card.stories";
import type { slideContent } from "@/types";
import type { Meta } from "@storybook/react";
import slugify from "slugify";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Button from "../Cards/Button";
import Card from "../Cards/Card";

interface SliderProps {
    slideContnent: slideContent[];
    paginationColor?: string;
    contentEl?: Meta;
    cardColor?: string;
    slidesToShow?: number;
    card?: boolean;
    element?: JSX.Element;
    border?: string;
}

export default function Slider({
    slideContnent,
    paginationColor = "#000",
    contentEl = CardLgWithImg || CardMdNoButton || CardMdHighNoButton || CardSm,
    cardColor = "bg-white",
    slidesToShow = 1,
    card = true,
    element,
    border = "border-2 border-gray-200",
}: SliderProps) {
    const pagination = {
        clickable: true,
    };
    return (
        <div>
            <Swiper
                pagination={pagination}
                modules={[Pagination, Navigation]}
                style={{
                    //@ts-ignore
                    "--swiper-pagination-color": paginationColor,
                    "--swiper-pagination-bullet-inactive-color": `${paginationColor}`,
                }}
                autoplay={{
                    delay: 200,
                }}
                slidesPerView={slidesToShow}
                spaceBetween={10}
            >
                {card ? (
                    <>
                        {slideContnent?.map((card) => (
                            <SwiperSlide key={card.slug}>
                                <div className="flex justify-center items-center">
                                    <Card
                                        backgroundColor={cardColor || card?.color}
                                        border={border}
                                        buttonPlacement={contentEl.args?.buttonPlacement}
                                        content={card?.content || card.excerpt}
                                        contentSize={contentEl.args?.contentSize}
                                        hasButton={contentEl.args?.hasButton}
                                        hasImage={contentEl.args?.hasImage}
                                        hasText={contentEl.args?.hasText}
                                        height={contentEl.args?.height}
                                        imageSize={contentEl.args?.imageSize}
                                        title={card.title}
                                        titleSize={contentEl.args?.titleSize}
                                        width={contentEl.args?.width}
                                        imgSrc={
                                            card?.img ?? card?.cover_media?.public_url
                                        }
                                        textSize={contentEl.args?.textSize}
                                        button={
                                            <div className="absolute bottom-6">
                                                <Button
                                                    backgroundColor={"bg-black"}
                                                    hasIcon={ButtonDark.args?.hasIcon}
                                                    size={"w-fit h-15"}
                                                    as="a"
                                                    href={`/de/${
                                                        card.category &&
                                                        slugify(card.category, {
                                                            lower: true,
                                                        })
                                                    }/${
                                                        card.subcategories?.[0] &&
                                                        slugify(card.subcategories[0], {
                                                            lower: true,
                                                        })
                                                    }/${card.slug}`}
                                                    paddings="px-5 py-4"
                                                />
                                            </div>
                                        }
                                        leadings=""
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </>
                ) : (
                    <>
                        <div className="flex w-full justify-center items-center">
                            {element}
                        </div>
                    </>
                )}
                <div className="h-10" />
            </Swiper>
        </div>
    );
}
